import React, { Component, useContext } from "react";
import ReactDOM from 'react-dom';
import MyDossierFileItem from "./MyDossierFileItem";
import axios from "axios"
import Pagination from "./Pagination";
import MySharedDossierFileItem from "./MySharedDossierFileItem"
import { LangContext } from "../LangContext.jsx";

class SharedDossierFilesPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      ids: {},
      searchActive: false,
      pagination: { page: 1 },
      files: { data: [], total: 0 },
    };
  }

  getFiles = async () => {
    const { dossier_id } = this.props;
    const request = await axios.get(`/api/shared_dossier/${dossier_id}/files`)
    this.setState({ ids: request.data.ids, files: request.data.data })
  }

  getFilteredFiles = async () => {
    const { dossier_id } = this.props;
    const { pagination } = this.state;
    const qs = new URLSearchParams();
    qs.append('page', pagination.page)
    if (qs !== "") {
      const request = await axios.get(`/api/shared_dossier/${dossier_id}/files?${qs}`)
      this.setState({ files: request.data.data, searchActive: true })
    } else {
      this.setState({ searchActive: false })
      this.getFiles()
    }
  }

  handleFiltering = (e) => {
    this.setState((prev) => ({ filters: { ...prev.filters, [e.target.name]: e.target.value } }))
  }

  updateCurrentPage = (tab, page) => {
    this.setState((prev) => ({ pagination: { ...prev.pagination, page } }))
  }

  componentDidMount() {
    this.getFiles()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters || prevState.pagination.page !== this.state.pagination.page) {
      this.getFilteredFiles()
    }
  }

  render() {
    const { lang } = this.context;
    const { external, permissions, is_internal } = this.props;
    const { ids, files, pagination } = this.state;
    return (
    <>
    <div className="d-flex justify-content-between align-items-end">
        <div>

        <h5 className="text-dark font-weight-bold my-5">
        <small className="text-muted font-weight-bold">{lang.get('messages.resultados_de_la_busqueda')}:</small>
        &nbsp; {files.total} &nbsp;
        <small className="text-muted font-weight-bold">{lang.get('messages.documentos_encontrados')}</small>
        </h5>
        </div>
        {external == 1 &&
        <a className="btn btn-primary" href={"/files/shared_download/"+ JSON.stringify(ids)}>
            <img src="/assets/img/icons/download.svg" className="mr-3" />
            {lang.get('messages.descargar_todos')}
        </a>
        }
        {external == 0 &&
        <a className="btn btn-primary" href={"/files/download/"+ JSON.stringify(ids)}>
            <img src="/assets/img/icons/download.svg" className="mr-3" />
            {lang.get('messages.descargar_todos')}
        </a>
        }
    </div>

      <div className="card card-custom my-5">
        <div className="card-body">
          <table className="table table-borderless m-0 table-valign">
            <thead>
              <tr>
                <th colSpan={2} >{lang.get('messages.nombre_del_archivo')}</th>
                <th>{lang.get('messages.formato')}</th>
                <th>{lang.get('messages.estatus')}</th>
                <th>{lang.get('messages.expiracion')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>

              {files.data?.map((file, idx) => (
                <MySharedDossierFileItem
                  key={idx}
                  file={file}
                  external={external}
                  permissions={permissions}
                  is_internal={is_internal}
                />
              ))}
            </tbody>
          </table>

          {files.total > 10 &&
            <Pagination
              updateCurrentPage={this.updateCurrentPage}
              currentPage={pagination.page}
              totalFiles={files.total}
              split={10} />
          }
        </div>
      </div>
    </>
  )
  }
}

export default SharedDossierFilesPanel;

if (document.getElementById('SharedDossierFilesPanel')) {
    ReactDOM.render(<SharedDossierFilesPanel />, document.getElementById('SharedDossierFilesPanel'));
}

